import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";
import CommissionPage from "../../partners/commission/CommissionPage";

export default function Commissions() {
  const [commissions, setCommissions] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const [summaryRes, listRes] = await Promise.all([
          authFetch(`${API_URL}/partner/commission-summary/`),
          authFetch(`${API_URL}/partner/commissions/`)
        ]);

        const summaryData = await summaryRes.json();
        const listData = await listRes.json();

        setSummary(summaryData);
        setCommissions(listData);
      } catch (err) {
        console.error("Error loading commissions:", err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) {
    return <div className="commissions-loading">Loading commissions...</div>;
  }

  return (
    <div>
      <CommissionPage commissions={commissions} summary={summary} />
    </div>
  );
}